Object.assign = require('object-assign');

require('babel-polyfill');
require('angular');
require('angular-sanitize');

// i18n
require('angular-translate');
require('angular-translate-loader-static-files');
require('angular-translate-storage-cookie');

require('ngRoute');
require('@sentry/browser');
require('ngResource');
require('ngMd5');

require('bootstrap-webpack');
require('angular-cookies');

window.Notify = require('notifyjs');
window.Clipboard = require('clipboard');
window.moment = require('moment');
require('momentTz');

require('angular-intercom');

require('rtc-screenshare');
require('quickconnect');
require('ngDraggableUi');

window.libphone = require('libphonenumber-js');
require('jssip');

require('webrtc-troubleshoot');
require('angular-vs-repeat');



/*****************
 ** WEBPACK FOOTER
 ** ./app/vendor.js
 ** module id = 0
 ** module chunks = 1
 **/